import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

interface HelperProps {
  content: string;
}

const Helper: React.FC<HelperProps> = ({ content }) => {
  const popover = (
    <Popover id="helper-popover">
      <Popover.Body>{content}</Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="bottom"
      overlay={popover}
      delay={{ show: 200, hide: 0 }}
      popperConfig={{ strategy: 'fixed' }}
    >
      <span
        className="d-inline-flex align-items-center justify-content-center mb-1"
        style={{ width: 16, height: 16, fontSize: 14 }}
        tabIndex={0}
      >
        <strong>?</strong>
      </span>
    </OverlayTrigger>
  );
};

export default Helper;
